<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title23"></a>
<div class="p-c"><span><strong class="b">FOR LILI</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429996211_ded01.vue?19df8d70